import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollToHash } from '../components/ScrollToHash';
import { Hero } from '../components/Hero';
import { TrustedBy } from '../components/TrustedBy';
import { SelectedWork } from '../components/SelectedWork';
import { Process } from '../components/Process';
import { Services } from '../components/Services';
import { Studio } from '../components/Studio';
import { Differentiators } from '../components/Differentiators';
import { Testimonials } from '../components/Testimonials';
import { Faq } from '../components/Faq';
import { JournalTeaser } from '../components/JournalTeaser';
export function Home() {
  return <div className="w-full bg-[#F2F2F2]" data-id="element-402" data-mp="2dhyvckpq1cs1">
      <ScrollToHash data-id="element-403" data-mp="2dj1jikvnt149" />
      <a href="#main" className="skip-link" data-id="element-404" data-mp="3kvafowjiyu0a">
        Skip to content
      </a>
      <Navbar data-id="element-405" data-mp="3kxd3d9x7gb1u" />
      <main id="main" data-id="element-406" data-mp="3kxmwv7hgl0ca">
        <Hero data-id="element-407" data-mp="3owcexddfz629" />
        <TrustedBy data-id="element-408" data-mp="3ovuavukjfnjs" />
        <SelectedWork data-id="element-409" data-mp="3ovar08bbup34" />
        <Process data-id="element-410" data-mp="3oyyk56cv19hb" />
        <Services data-id="element-411" data-mp="30wrt0rjcmhkt" />
        <Studio data-id="element-412" data-mp="30xb5hsq8cdrg" />
        <Differentiators data-id="element-413" data-mp="30vqay33x0utl" />
        <Testimonials data-id="element-414" data-mp="30w039xcfne2g" />
        <Faq data-id="element-415" data-mp="2vxow5udivhnx" />
        <JournalTeaser data-id="element-416" data-mp="2vxycsrcogcgy" />
      </main>
      <Footer data-id="element-417" data-mp="2vyzx7mfl2bbc" />
    </div>;
}